import * as React from 'react';

import { useGlobalState } from '~src/global-state';

import { BillingAddressManagerFSM } from './billing-address-renderer-fsm';

// hide all logic behind feature flag.
export const BillingAddressManagerProxy: React.VFC = () => {
  const globalState = useGlobalState();

  /**
   * don't show the module if delivery address form or billing address is disabled
   */
  if (
    !globalState.use_recipient_address ||
    !globalState.address_form_configuration?.features?.show_billing_address
  ) {
    return null;
  }

  return <BillingAddressManagerFSM />;
};
